import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StockScrap } from '../_interfaces/stock-scrap';

export interface StockScrapInput {
  orderId?: number | null;
  orderItemId?: number | null;
  productVariantId: number;
  quantity: number;
  warehouse: string;
  reason?: string;
  notes?: string;
}

export interface StockScrapQueryParams {
  pageIndex: number;
  pageSize: number;
  productVariantId?: number;
  orderId?: number;
  warehouse?: string;
  reason?: string;
  // 'auto' (written by the delivery validation screen) | 'manual' (logged by hand here)
  source?: string;
  keyword?: string;
}

export interface StockScrapStats {
  total: number;
  units: number;
  auto: number;
  manual: number;
}

export interface StockScrapQueryResult {
  items: StockScrap[];
  count: number;
  stats: StockScrapStats;
}

@Injectable({
  providedIn: 'root',
})
export class StockScrapService {
  constructor(private http: HttpClient) {}

  listScrap(params: StockScrapQueryParams): Observable<StockScrapQueryResult> {
    return this.http.post<StockScrapQueryResult>('/stock-scrap/list', params);
  }

  createScrap(input: StockScrapInput): Observable<StockScrap> {
    return this.http.post<StockScrap>('/stock-scrap', input);
  }
}
